enum Web {
  SINGLE_SIGN_ON = 'web-react-sso',
  REQUIRE_MOBILE_PHONE = 'web-react-require-mobile-phone',
  PRO_USER_SMS_CONSENT = 'web-pro-user-onboarding-sms-consent-checkbox',
  RENDERINGS_SIGNUP_BANNER = 'web-renderings-signup-banner',
  PROPERTY_DETAILS = 'web-property-details',
  JOB_SHARING_MVP = 'job-sharing-mvps',
  PROPERTY_DETAILS_PHOTOS_TAB = 'web-property-details-photos-tab',
  PAINT_MEASUREMENTS = 'GPAR-paint-measurement-report',
  PAYMENT_BANNER = 'payment-banner',
  IMPERSONATION_BANNER = 'commerce-impersonation-banner',
  JOBS_PAGE = 'jobs-page',
}

enum Mobile {}

enum DesignStudio {
  DS_MACHETE_ENVIRONMENT_TYPE = 'DS_macheteEnvironmentTypeTreatment',
  DS_MACHETE_QUALITY = 'DS_macheteQualityTreatment',
  DS_MACHETE_USE_PRODUCTS_LIBRARY_FOR_TEXTURING = 'DS_useProductsLibraryForTexturingTreatment',
  DS_MACHETE_PAINT_OVER_GRAYSCALE = 'DS_machetePaintOverGrayscale',
  DS_SHOW_DESIGN_CHANGES_IN_PRO = 'DS_show-design-changes-in-pro-view',
  DS_SHOW_DESIGN_CHANGES_IN_SHARE = 'DS_show-design-changes-in-share',
  DS_JH_PRODUCTS = 'DS_james-hardie-products',
  DS_INSPIRE_ME = 'DS_inspire-me',
  HIGH_DEF_RENDERING_CTA = 'he_rendering-cta',
  DS_DESIGN_TOOL_IS_STUDIO = 'DS_design-tool-is-studio',
  DS_V1 = 'design-studio-v1',
  DS_DOOR_GROUPS = 'design-studio-door-changing',
  DS_DOOR_GROUPS_DEBUGGING = 'design-studio-door-changing-debugging',
}

enum AiDesigner {}

enum FeatureTracking {
  RENDERING = 'rendering',
  AI_DESIGNER = 'ai-designer',
  INSPIRE_ME = 'inspire-me',
  HOMEOWNER_APP = 'homeowner-app',
}

enum Renderings {
  RENDERINGS_SHARE_CTA = 'he_renderings-hub-signup-cta',
  RENDERINGS_FOR_NEW_CONSTRUCTION = 'new-construction-additions',
}

enum Commerce {
  COMMERCE_ACTIVE_COMMERCE_PRODUCT = 'commerce-user-active-commerce-product',
}

enum NewConstruction {
  NEW_CONSTRUCTION_WEB_REACT_UI = 'new-construction-web-react-ui',
  NEW_CONSTRUCTION_BUILD_ALL = 'new-construction-build-all-wizard-of-oz',
}

const Value = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

const localhostFeaturesKey = 'local-split-features';

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Value = (typeof Value)[keyof typeof Value];

export {
  DesignStudio,
  Renderings,
  Mobile,
  Value,
  Web,
  localhostFeaturesKey,
  FeatureTracking,
  AiDesigner,
  Commerce,
  NewConstruction,
};
